module.exports = __webpack_public_path__ + "img/Warehouse.589711cb.svg";